// extracted by mini-css-extract-plugin
export default {"container":"VerifyAccount_container__fGYaG","box":"VerifyAccount_box__t19eY","resendButton":"VerifyAccount_resendButton__+BErM"};